import { z } from 'zod';
export const idSchema = z.string().min(1);
export const vec2Schema = z.object({
    x: z.number(),
    y: z.number(),
});
export const vec3Schema = vec2Schema.extend({
    z: z.number(),
});
export const normalizedVec2Schema = z.object({
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
});
export const normalizedRectSchema = z.object({
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    width: z.number().min(0).max(1),
    height: z.number().min(0).max(1),
});
export const colorSchema = z.union([
    z.string().regex(/^#[0-9a-fA-F]{3,8}$/),
    z.string().regex(/^(rgb|rgba|hsl|hsla)\(/),
    z.object({
        r: z.number().min(0).max(1),
        g: z.number().min(0).max(1),
        b: z.number().min(0).max(1),
        a: z.number().min(0).max(1).default(1),
    }),
]);
export const easingSchema = z.object({
    type: z.enum(['linear', 'ease-in', 'ease-out', 'ease-in-out', 'hold']).default('linear'),
    power: z.number().positive().optional(),
    overshoot: z.number().positive().optional(),
});
export const keyframeSchema = z.object({
    time: z.number().min(0),
    value: z.union([z.number(), z.string(), z.boolean(), vec2Schema, vec3Schema]),
    easing: easingSchema.optional(),
});
export const keyframeTrackSchema = z.object({
    property: z.string(),
    keyframes: z.array(keyframeSchema).min(1),
});
//# sourceMappingURL=common.js.map